import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import Modal from 'react-modal'
import { Checkbox, Flex, Text } from 'components/ds'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import modalStyles from 'components/utils/modalStyles'
type Props = {
  onConfirm: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
  onHideWarningChange: (...args: Array<any>) => any
  hideWarning: boolean
}
export default class DropConfirmationDialog extends React.Component<Props> {
  render(): React.ReactNode {
    return (
      <Modal style={modalStyles} isOpen onRequestClose={this.props.onCancel}>
        <Theme>
          <div className="Dialog">
            <div>
              <p>
                You&#39;re about to add a track to this playlist. If this is
                what you meant to do: good! If not, click{' '}
                <b>Don&#39;t add track</b>.
              </p>
              <p>
                If you&#39;ve sent this playlist out to anyone, please note that
                updating this playlist will also update what your recipients see
                when they access it.{' '}
              </p>
            </div>
            <Flex gap="2" align="center" justify="between">
              <Text as="label" size="2">
                <Flex gap="2">
                  <Checkbox
                    defaultChecked={this.props.hideWarning}
                    onCheckedChange={this.props.onHideWarningChange}
                  />
                  Don&#39;t show this warning again
                </Flex>
              </Text>
              <ButtonContainer>
                <Button
                  caption="Don’t add track"
                  onClick={this.props.onCancel}
                />
                <Button
                  caption="Add track"
                  onClick={this.props.onConfirm}
                  appearance="primary"
                />
              </ButtonContainer>
            </Flex>
          </div>
        </Theme>
      </Modal>
    )
  }
}
